import { useRef } from "react";
import HeroSection from "./components/HeroSection";
import PopularCategoriesSection from "./components/PopularCategoriesSection";
import HowItWorksSection from "./components/HowItWorksSection";
import OurMissionSection from "./components/OurMissionSection";
import LevelUpYourBusinessSection from "./components/LevelUpYourBusinessSection";
import ReviewsSection from "./components/ReviewsSection";
import Footer from "./components/Footer";

export default function HomePage() {
  const searchInputRef = useRef<HTMLInputElement>(null);

  const focusSearchInput = () => {
    searchInputRef.current?.focus({ preventScroll: true });
  };

  return (
    <div className="min-h-dvh bg-white w-full text-foreground">
      <div className="flex flex-col h-svh sm:h-auto justify-between">
        <HeroSection
          searchInputRef={searchInputRef}
          classNames={{ base: "grow" }}
        />
        <PopularCategoriesSection
          classNames={{ base: "max-w-page sm:px-5 mx-auto" }}
        />
      </div>
      <OurMissionSection
        classNames={{ base: "max-w-page px-4 sm:px-5 mx-auto py-12 sm:pb-24" }}
      />
      <HowItWorksSection
        onStartNowPress={focusSearchInput}
        classNames={{
          base: "bg-default-100 font-light",
          container: "max-w-page px-4 sm:px-5 mx-auto py-14 sm:py-20"
        }} />
      <ReviewsSection />
      <LevelUpYourBusinessSection
        classNames={{ container: "max-w-[985px] mx-auto font-light" }}
      />
      <Footer />
    </div>
  );
}
